import RoundedThemeButton from './RoundedThemeButton'

export default RoundedThemeButton
